module.exports = __webpack_public_path__ + "img/grip1.7f04afc0.png";